import PagesApi from '@/frontend/api/pages'

export default pageName => {
    PagesApi.get({id: pageName})
        .then(response => {
            document.title = response.title || response.name || 'l-collection'
            document.querySelector('meta[name="description"]').setAttribute("content", response.description)
        })
        .catch(error => console.error('Ошибка установки мета тегов: ' + error))
}